import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetAllPromotionKitApi = (params) => api.get(`promotionkit/get-all-promotionkit?${qs(params)}`);
export const GetAllpromotionByIdApi = (id) => api.get(`PromotionKit/GetPromotionKitById/${id}`);